import { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { formatDeliveryAddress } from 'containers/Cart/utils'

import messages from './messages'

export const isAnyFloatingPriceInCart = cartData =>
  cartData?.modifiers.includes('floating_price')

export const useCartDeliveryAddress = ({
  deliveryAddress,
  deliveryPostcode,
  deliveryCity,
}) => {
  const { formatMessage } = useIntl()

  const addressFormatted = useMemo(
    () =>
      deliveryAddress
        ? formatDeliveryAddress({
            deliveryAddress,
            deliveryPostcode,
            deliveryCity,
          })
        : formatMessage(messages.lackOfDeliveryAddress),
    [deliveryAddress, deliveryPostcode, deliveryCity],
  )

  return addressFormatted
}

export const getCartUnitsOfMeasure = cartItem =>
  cartItem.positions.map(position => ({
    unitOfMeasure: position.measurement.unit,
    unitOfMeasureDescription: position.measurement.description,
    quantity: position.measurement.quantity,
    multiplier: position.measurement.multiplier,
    inCartQuantity: position.quantity,
    priceNet: position.totalPrice.net,
    priceGross: position.totalPrice.gross,
    stock: position.measurement.availableStock,
    // "is_stock_limited": false, // TODO: add this to the API response
  }))
